import MidtermAndFinalExam from './component';

import _routes from './routes';

export const routes = _routes;

export default MidtermAndFinalExam;



// WEBPACK FOOTER //
// ./containers/Group/MidtermAndFinalExam/index.js